import Sidebar from './Sidebar.vue';
export * from './types';
export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/sidebar/index.ts